var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#271CF7;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#195DA9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_589_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_592_",
    className: "st2",
    d: "M369.7,6L369.7,6H158.8c-6.3,0-11.4,5.2-11.4,11.4v352.4h22.8v-341h199.5V108h79.2v304.6 H170.2v-42.8h-22.8v54.2c0,6.3,5.2,11.4,11.4,11.4h301.5c6.3,0,11.4-5.2,11.4-11.4V108L369.7,6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_591_",
    x: 200.7,
    y: 148.1,
    className: "st2",
    width: 217.7,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_590_",
    x: 200.7,
    y: 180.8,
    className: "st2",
    width: 183.2,
    height: 16.8
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "87.7,484.2 87.7,65.3 297.3,69.8 384.1,156.8 379.8,487.2 92.8,487.2  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st4",
    d: "M297,49.9L297,49.9H82.6c-6.4,0-11.6,5.4-11.6,12v371.5h23.2V74H297v83.5h80.5v321.1H94.2 v-45.1H71v57.1c0,6.6,5.2,12,11.6,12h306.6c6.4,0,11.6-5.4,11.6-12V157.5L297,49.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7_",
    x: 125.2,
    y: 199.7,
    className: "st4",
    width: 221.4,
    height: 17.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    x: 125.2,
    y: 234.2,
    className: "st4",
    width: 186.3,
    height: 17.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "141.9,442.1 141.9,23.2 351.6,27.7 438.3,114.7 434,445.1 147,445.1  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st4",
    d: "M351.3,7.8L351.3,7.8H136.8c-6.4,0-11.6,5.4-11.6,12v371.5h23.2V31.9h202.8v83.5h80.5v321.1 H148.5v-45.1h-23.2v57.1c0,6.6,5.2,12,11.6,12h306.6c6.4,0,11.6-5.4,11.6-12V115.4L351.3,7.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 179.5,
    y: 157.6,
    className: "st4",
    width: 221.4,
    height: 17.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 179.5,
    y: 192.1,
    className: "st4",
    width: 186.3,
    height: 17.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a975d4872693b01d82a03206352017f3.svg";
export { ForwardRef as ReactComponent };